/**
 * Pendo analytics integration for mobile app
 */

/**
 * Get current user context for Pendo events
 * Includes user role for segmentation
 */
function getUserContext() {
    const user = $f.active_user;
    if (!user) {
        return {};
    }

    return {
        user_role: user.get('role')
    };
}

/**
 * Get current platform context for Pendo events
 */
function getPlatformContext() {
    return {
        platform: $f.mobile.settings.get_platform_type()
    };
}

/**
 * Get current company context for Pendo events
 */
function getCompanyContext() {
    const company = $f.active_company;
    if (!company || !company.id) {
        return {};
    }

    return {
        company_id: company.id,
        company_name: company.get('name')
    };
}

/**
 * Merge user and company context with provided options
 */
function mergeContextWithOptions(options = {}) {
    return {
        ...getUserContext(),
        ...getCompanyContext(),
        ...getPlatformContext(),
        ...options
    };
}

/**
 * Track a custom event in Pendo
 * @param {string} eventName - Name of the event to track
 * @param {object} options - Optional metadata to include with the event (automatically includes user/company context)
 */
function pendoTrack(eventName, options) {
    if (typeof window.pendo === 'undefined') {
        return;
    }

    try {
        const eventData = mergeContextWithOptions(options);
        window.pendo.track(eventName, eventData);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error tracking Pendo event:', error);
    }
}

/**
 * Track a page load / route change in Pendo for SPA navigation
 * @param {object} options - Optional metadata including url, pathname, etc. (automatically includes user/company context)
 */
function pendoPageLoad(options) {
    if (typeof window.pendo === 'undefined') {
        return;
    }

    try {
        const pageData = mergeContextWithOptions(options);
        window.pendo.pageLoad(pageData);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error calling Pendo pageLoad:', error);
    }
}

module.exports = {
    pendoTrack,
    pendoPageLoad,
    getUserContext,
    getCompanyContext,
    getPlatformContext
};
